export const employers = [
  {
    id: 1,
    picture: "nawreen.jpg",
    name: "Rifat Nawreen",
    narration:
      "Rifat Nawreen, Senior Recruiter and one of the Cheerful Team Leader who also hunting fit candidates for Recruiting Team of Steadfast International Services, LLC. She is Versatile, Loyal & Dedicated to Organizational growth.",
  },
  {
    id: 2,
    picture: "shakhawat.jpg",
    name: "Shakhawat Hossain",
    narration:
      "Shakhawat Hossain, Assistant HR Manager of Steadfast International Services, LLC. His strongest asset is his multitasking ability. He is conduct interviews & hunts fit candidates for Recruiting Team.",
  },
  {
    id: 3,
    picture: "brishty.jpg",
    name: "Tasnima Rahman Bristy",
    narration:
      "Tasnima Rahman Bristy worked here as an executive recruiter. She believe one can easily achieve success by being patient, sincere and believing in self. Maintaining proper determination and friendly environment is the key here.",
  },
  {
    id: 4,
    picture: "hamidul.jpg",
    name: "MD. Hamidul Hoque",
    narration:
      "Md. Hamidul Hoque is Most patinate , hard working Executive Recruiter who supports candidates to get their desire job and providing a great service through out the process.",
  },

  {
    id: 5,
    picture: "ridi.jpg",
    name: "Mahtareen Haque Ridi",
    narration:
      "Mahtareen Haque Ridi, is an Executive Recruiter at Steadfast International Services, LLC who is determined to get the job done correctly and efficiently. She is a multi-skilled individual who has goals, morals and knows how to follow guide lines and rules.",
  },
  {
    id: 6,
    picture: "mostafa.png",
    name: "S.M. Mostafa Jamal",
    narration:
      "S.M. Mostafa Jamal a Technical Recruiter as well as Computer Science Student fond of web development/software engineering, he has a unique perspective on both sides of the hiring process. In his role as a technical recruiter, he gained a deep understanding of what companies look for in a software engineers, as well as the challenges they face in finding and hiring top talent. As a technical recruiter, he use his experience to find and hiring the best technical talent for many organization. He is able to speak their language and understand the technical requirements of the job, making it easier for him to tailor his application and stand out from other candidates.",
  },
  {
    id: 7,
    picture: "amin.jpg",
    name: "Abdullah AL Amin",
    narration: `This is Amin working as an Executive Recruiter being well organized, truthful and passionate. A pioneer is an individual who knows the path, goes the path and shows the path.`,
  },
  {
    id: 8,
    picture: "nishat.jpg",
    name: "Nishat Anjum",
    narration: `Nishat Anjum is delighted to be a part of Steadfast International Services, where she can use her skills and talents to demonstrate her expertise and boost the company's growth.`,
  },
  {
    id: 9,
    picture: "tahmid.jpg",
    name: "Tahmid Ahmed",
    narration:
      "Tahmid Ahmed is a recruiter responsible for finding and attracting talented individuals to fill job openings within the organization they represent. They create job descriptions and postings, screen resumes and applications, conduct interviews, and act as a point of contact for candidates throughout the recruitment process.",
  },
  {
    id: 10,
    picture: "zubair.png",
    name: "Sheikh Sauban Zubair ",
    narration:
      "Sheikh Sauban Zubair currently operates as a management trainee officer at Steadfast. He looks to source candidates from different backgrounds using his expertise in different fields as well as his vast knowledge of different cultures. As one of the youngest members at Steadfast, he is always striving to learn and improve on his previous work.",
  },

  {
    id: 11,
    picture: "shubrata.jpg",
    name: "Shubrata Das",
    narration:
      "Shubrata Das is an optimistic person and a learning enthusiast who is deeply passionate for making amazing contributions in ensuring ceaseless personal and professional growth for himself. He's strongly spirited for ensuring brilliant footsteps in his career and highly committed to work with integrity, diligence and agility for the tasks, duties and responsibilities given to him within a job.",
  },

  {
    id: 12,
    picture: "adhora.jpg",
    name: "Adhora Zaman",
    narration:
      "Adhora Zaman is a highly motivated and energetic recruitment Professional. She is an effective communicator and negotiator maintaining strong working relationships with clients, leadership teams, and her peers. She possesses excellent time management skills as well as the ability to handle multiple tasks simultaneously and operate effectively within strict deadlines and challenging situations.",
  },
  {
    id: 13,
    picture: "mahim.jpg",
    name: "Mahmudur Rahman",
    narration:
      "This is Mahmudur Rahman born and raised in the Chattogram. I have done my post Graduation from Port City International University majoring in HRM now working in Steadfast International Service, LLC. as a Management Trainee Officer. I help Job seekers to find their desired job.",
  },
  {
    id: 14,
    picture: "jahid.jpg",
    name: "Khandokar Jahidul",
    narration:
      "Khandokar Jahidul, Holds the management trainee officer position at Steadfast Internationals Services LLC. Passionate about headhunting. Sourcing and attracting candidates by using databases and different platforms. Prepare recruitment materials and post jobs for the appropriate jobs.",
  },
];
